module.exports = __webpack_public_path__ + "img/17-full-sm.a95ba004.jpg";